/* eslint-disable no-underscore-dangle */
const finalTaskDelay = 100;

const createSubscriberPeerConnectionQueue = () => {
  let queue = [];
  let isProcessing = false;
  let timeoutId;
  let finalTask;
  let finalTaskId;
  let lastId = 0;
  let processingId = null;

  const processFinalTaskWithDelay = () => {
    timeoutId = setTimeout(() => {
      timeoutId = undefined;
      isProcessing = true;
      processingId = finalTaskId;
      finalTask();
      finalTask = undefined;
    }, finalTaskDelay);
  };

  const enqueue = (task) => {
    lastId += 1;
    if (isProcessing) {
      queue.push({ task, id: lastId });
    } else {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      isProcessing = true;
      processingId = lastId;
      task();
    }
    return lastId;
  };

  const finallyTask = (task) => {
    lastId += 1;
    finalTaskId = lastId;
    finalTask = task;
    if (isProcessing) {
      return finalTaskId;
    }

    if (timeoutId) {
      // do nothing, we have updated the finalTask but we need not extend the time
      return finalTaskId;
    }
    processFinalTaskWithDelay();
    return finalTaskId;
  };

  const dequeueAndProcessNext = (taskId) => {
    if (taskId === processingId) {
      const queueItem = queue.shift();
      if (queueItem?.task) {
        processingId = queueItem.id;
        queueItem.task();
      } else {
        if (finalTask) {
          processFinalTaskWithDelay();
        }
        isProcessing = false;
        processingId = null;
      }
    }
  };

  const cancel = (taskId) => {
    if (taskId === finalTaskId) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = undefined;
      }
      finalTask = undefined;
      finalTaskId = null;
    } else {
      queue = queue.filter(item => item.id !== taskId);
    }
  };

  return {
    enqueue,
    finally: finallyTask,
    dequeueAndProcessNext,
    cancel,
  };
};

export default createSubscriberPeerConnectionQueue;
